module.exports = __webpack_public_path__ + "static/media/bar.5cdc68f5.png";